<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">自主檢驗超時</div>
      <div style="margin-top: 2rem">
        <commonQueryInput :inputItems="multiInputItems" v-model:getValue="multiInputVal"></commonQueryInput>
      </div>
      <div style="margin-top: 2rem">
        <template v-if="!inspectTimeoutShowDetail">
          <commonTable :fields="inspectTimeoutDataFields" :items="inspectTimeoutDataItem"
            :rowClick="inspectTimeoutRowClick" stickyHeader="610px" class="inspectTimeout-table">
            <template #thead-top="">
              <tr>
                <th>機台總數</th>
                <th>總生產批數</th>
                <th>總檢驗筆數</th>
                <th>總超時筆數</th>
              </tr>
              <tr @click="inspectTimeoutRowClick(null)">
                <th>{{ deviceTotalQty.toLocaleString("en-US") }}</th>
                <th>{{ batchTotalQty.toLocaleString("en-US") }}</th>
                <th>{{ inspectTotalQty.toLocaleString("en-US") }}</th>
                <th>{{ timeoutTotalQty.toLocaleString("en-US") }}</th>
              </tr>
              <tr>
                <th colspan="4">超時分析</th>
              </tr>
              <tr>
                <th v-for="data in inspectTimeoutDataFields">
                  {{ data.label }}
                </th>
              </tr>
            </template>
          </commonTable>
        </template>
        <template v-else>
          <div class="text-start mb-3">
            <button class="inspectTimeout-button mx-0" @click="inspectTimeoutShowDetail = false">
              返回
            </button>
          </div>
          <commonTable :fields="inspectTimeoutDetailDataFields" :items="inspectTimeoutDetailDataItem"
            stickyHeader="610px" class="">
            <template #header>超時分析</template>
            <template #cell(batch)="data">
              <div class="w-100 h-100" style="cursor: pointer; align-content: center"
                @click="showDetailData('batch', data.item)">
                {{ data.value }}
              </div>
            </template>
            <template #cell(lastTime)="data">
              <div class="w-100 h-100" style="cursor: pointer; align-content: center"
                @click="showDetailData('lastTime', data.item)">
                {{ data.value }}
              </div>
            </template>
          </commonTable>
        </template>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
  <commonModal :modalShow="modalShow" :size="'xl'">
    <template v-slot:modalheader>
      <button type="button" class="close" @click="modalShow = false">×</button>
    </template>
    <template v-slot:default>
      <template v-if="modalShowCategory == 'batch'">
        <div class="text-start">批號:{{ batch }}</div>
        <div class="mt-4 p-3" style="background-color: #f2f2f2">
          <ul class="nav mb-3">
            <li class="li-tab inspection-head-tab" :class="{ 'inspection-head-tab-active': inspectTabIndex == 0 }"
              @click="inspectTabIndex = 0">
              打頭
            </li>
            <li class="li-tab inspection-thread-tab"
              :class="{ 'inspection-thread-tab-active': inspectTabIndex == 1, 'd-none': totalInspectionData.length < 2, }"
              @click="inspectTabIndex = 1">
              輾牙
            </li>
          </ul>
          <inspectionList :inspectionData="inspValue"></inspectionList>
        </div>
      </template>
      <template v-else-if="modalShowCategory == 'lastTime'">
        <div style="margin-top: 2rem">
          <queryResultTable :queryResultTableItems="queryResultTableItems" />
        </div>
        <div style="margin-top: 2rem">
          <stackBar :stacksBarClass="stacksBarClass" :stacksBarMaxValue="stacksBarMaxValue" :stacksData="stacksData"
            :stacksSize="'normal'" />
        </div>
        <commonTable :fields="operateLogFields" :items="operateLogItems" :theme="'green'" stickyHeader="230px">
          <template #cell(status)="data">
            <template
              v-if="data.item.alarmCode != '' && data.item.alarmCode.indexOf('E_MC_3_') != -1 && data.item.status == '警報'">
              <b style="color: red">{{ data.value }}</b>
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
          <template #cell(alarmCode)="data">
            <template
              v-if="data.item.alarmCode != '' && data.item.alarmCode.indexOf('E_MC_3_') != -1 && data.item.status == '警報'">
              <b style="color: red">{{ data.value }}</b>
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
          <template #cell(alarmDetail)="data">
            <template
              v-if="data.item.alarmCode != '' && data.item.alarmCode.indexOf('E_MC_3_') != -1 && data.item.status == '警報'">
              <b style="color: red">{{ data.value }}</b>
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
          <template #cell(startTime)="data">
            <template
              v-if="data.item.alarmCode != '' && data.item.alarmCode.indexOf('E_MC_3_') != -1 && data.item.status == '警報'">
              <b style="color: red">{{ data.value }}</b>
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
          <template #cell(endTime)="data">
            <template
              v-if="data.item.alarmCode != '' && data.item.alarmCode.indexOf('E_MC_3_') != -1 && data.item.status == '警報'">
              <b style="color: red">{{ data.value }}</b>
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
          <template #cell(durationTime)="data">
            <template
              v-if="data.item.alarmCode != '' && data.item.alarmCode.indexOf('E_MC_3_') != -1 && data.item.status == '警報'">
              <b style="color: red">{{ data.value }}</b>
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
        </commonTable>
      </template>
    </template>
  </commonModal>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import queryResultTable from "@/components/queryResultTable.vue";
import stackBar from "@/components/stackBar.vue";
import exportCsv from "@/components/exportCsv.vue";
import commonTable from "@/components/commonTable.vue";
import commonModal from "@/components/commonModal.vue";
import inspectionList from "@/components/inspectionList.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    queryResultTable,
    stackBar,
    exportCsv,
    commonTable,
    commonModal,
    inspectionList,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_inspProcess"]);
    const group = computed(() => store.getters["selectOptions/get_group"]);
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = computed(
      () => store.getters["stackBar/get_stacksBarMaxValue"]
    );
    const stacksBarDefault = computed(
      () => store.getters["stackBar/get_stacksBarDefault"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      set_device: (payload) => {
        store.dispatch("selectOptions/set_device", payload);
      },
    };

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "dateBetween", // date/dateBetween/text/select/time/month
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
      {
        key: "group",
        label: "組別",
        type: "select",
        bindKey: "oper",
        checkEmpty: false,
        disableText: "-- 選擇組別 --",
        bindOptions: group,
      },
    ]);

    const inspectTimeoutDataFields = [
      {
        key: "deviceName",
        label: "機台",
        thStyle: {
          width: "155px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "batchQty",
        label: "批數小計",
        thStyle: {
          width: "155px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspectQty",
        label: "檢驗筆數小計",
        thStyle: {
          width: "155px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "timeoutQty",
        label: "超時筆數小計",
        thStyle: {
          width: "155px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const inspectTimeoutDataItem = ref([]);

    const inspectTimeoutDetailDataFields = [
      {
        key: "deviceName",
        label: "機台",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
        rowspan: true,
        rowspanKey: 'timeoutQty',
      },
      {
        key: "batchQty",
        label: "批數小計",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
        rowspan: true,
        rowspanKey: 'timeoutQty',
      },
      {
        key: "inspectQty",
        label: "檢驗筆數小計",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
        rowspan: true,
        rowspanKey: 'timeoutQty',
      },
      {
        key: "timeoutQty",
        label: "超時筆數小計",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
        rowspan: true,
        rowspanKey: 'timeoutQty',
      },
      {
        key: "batch",
        label: "批號",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
          "padding": "0px",
          "border-left": "0px",
        },
      },
      {
        key: "lastTime",
        label: "前次檢驗時間",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
          padding: "0px",
        },
      },
      {
        key: "thisTime",
        label: "當次檢驗時間",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "intervalTime",
        label: "間隔時間",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const inspectTimeoutDetailDataItem = ref([]);

    const deviceTotalQty = ref(0);
    const batchTotalQty = ref(0);
    const inspectTotalQty = ref(0);
    const timeoutTotalQty = ref(0);
    const inspectTimeoutDetailData = ref([]);
    const site = ref([]);

    const modalShow = ref(false);
    const modalShowCategory = ref("");

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        console.log(newValue);
        params["methods"] = "POST";
        params["whichFunction"] = "inspectTimeout";
        params["startTime"] = newValue["date"]["startDate"] + " 00:00:00";
        params["endTime"] = newValue["date"]["endDate"] + " 23:59:59";
        params["oper"] = newValue["oper"];
        params["group"] = newValue["group"];

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData;
            deviceTotalQty.value = queryTableData.device_total_qty;
            batchTotalQty.value = queryTableData.batch_total_qty;
            inspectTotalQty.value = queryTableData.inspect_total_qty;
            timeoutTotalQty.value = queryTableData.timeout_total_qty;
            inspectTimeoutDataItem.value =
              queryTableData.inspectTimeoutDataItem;
            inspectTimeoutDetailData.value =
              queryTableData.inspectTimeoutDetailData;
            site.value = queryTableData.factory;
            inspectTimeoutShowDetail.value = false;
          } else {
            deviceTotalQty.value = 0;
            batchTotalQty.value = 0;
            inspectTotalQty.value = 0;
            timeoutTotalQty.value = 0;
            inspectTimeoutDataItem.value = [];
            inspectTimeoutDetailData.value = [];
            site.value = "";
            inspectTimeoutShowDetail.value = false;
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    watch(modalShow, (newValue) => {
      if (newValue == false) {
        modalShowCategory.value = "";

        batch.value = "";
        inspectTabIndex.value = -1;
        inspValue.value = {
          self: [],
          last: [],
          first: [],
        };
        queryResultTableItems.value = [];
        stacksData.value = stacksBarDefault.value;
        operateLogItems.value = [];
      }
    });

    const inspectTimeoutShowDetail = ref(false);
    const inspectTimeoutRowClick = (rowData = null) => {
      inspectTimeoutDetailDataItem.value = [];
      if (rowData == null) {
        let mergeData = [];
        inspectTimeoutDataItem.value.forEach((data) => {
          if (inspectTimeoutDetailData.value[data.deviceName] != undefined) {
            mergeData = mergeData.concat(
              inspectTimeoutDetailData.value[data.deviceName]
            );
          }
        });
        inspectTimeoutDetailDataItem.value = mergeData;
      } else {
        let deviceName = rowData.deviceName;
        if (inspectTimeoutDetailData.value[deviceName] != undefined) {
          inspectTimeoutDetailDataItem.value =
            inspectTimeoutDetailData.value[deviceName];
        }
      }
      inspectTimeoutShowDetail.value = true;
    };

    const batch = ref("");
    //檢驗項目
    const inspectTabIndex = ref(null);
    const totalInspectionData = ref([]);
    const inspValue = ref({
      self: [],
      last: [],
      first: [],
    });
    // watch tab 點擊改變
    watch(totalInspectionData, () => {
      inspectTabIndex.value = 0;
    },
      { deep: true }
    );
    watch(inspectTabIndex, (newValue) => {
      if (totalInspectionData.value.length == 0 || newValue == -1) {
        return;
      }
      inspValue.value = totalInspectionData.value[newValue]["data"];
    },
      { deep: true }
    );
    //運轉記錄
    const queryResultTableItems = ref([]);
    const stacksData = ref(stacksBarDefault.value);
    const operateLogFields = [
      {
        key: "status",
        label: "狀態",
        sortable: true,
        thStyle: {
          "min-width": "80px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmCode",
        label: "代碼",
        sortable: true,
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmDetail",
        label: "代碼說明",
        sortable: true,
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        sortable: true,
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        sortable: true,
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "durationTime",
        label: "持續時間",
        sortable: true,
        thStyle: {
          "min-width": "115px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const operateLogItems = ref([]);
    const showDetailData = (category, item) => {
      if (item.mainInsp == undefined) {
        return;
      }
      let mainInsp = item.mainInsp;
      let mainInsp_array = mainInsp.split("_");
      let oper = mainInsp_array[0];
      let device_name = mainInsp_array[1];
      let work_code = mainInsp_array[2];
      let timestamp = mainInsp_array[3];

      let params = {};

      switch (category) {
        case "batch":
          methods.triggerLoadingBar();
          params["webPage"] =
            sideNavPath.value.length != 0
              ? sideNavPath.value[sideNavPath.value.length - 1]
              : null;
          params["user"] = loginData.value.account;
          params["vuePage"] = path.value;
          console.log(path.value);
          params["methods"] = "POST";
          params["whichFunction"] = "getWorkInspData";
          params["device_name"] = device_name;
          params["work_code"] = work_code;
          params["timestamp"] = timestamp;
          params["site"] = site.value;

          methods.axiosAction(params).then(() => {
            console.log(axiosResult.value);
            let result = axiosResult.value;
            let response = result.Response;
            if (response == "ok") {
              let queryTableData = result.QueryTableData;
              batch.value = work_code;
              totalInspectionData.value =
                queryTableData.inspectionUseInformationData;
              modalShow.value = true;
              modalShowCategory.value = "batch";
            } else {
              methods.setTimeoutAlert(response);
            }
            methods.triggerLoadingBar();
          });
          break;
        case "lastTime":
          methods.triggerLoadingBar();
          params["webPage"] =
            sideNavPath.value.length != 0
              ? sideNavPath.value[sideNavPath.value.length - 1]
              : null;
          params["user"] = loginData.value.account;
          params["vuePage"] = path.value;
          console.log(path.value);
          params["methods"] = "POST";
          params["whichFunction"] = "getDeviceOperateData";
          params["oper"] = oper;
          params["device_name"] = device_name;
          params["work_code"] = work_code;
          params["timestamp"] = timestamp;
          params["site"] = site.value;

          methods.axiosAction(params).then(() => {
            console.log(axiosResult.value);
            let result = axiosResult.value;
            let response = result.Response;
            if (response == "ok") {
              let queryTableData = result.QueryTableData;
              queryResultTableItems.value = queryTableData.resultItemData;
              stacksData.value = queryTableData.stacksBar_data;
              operateLogItems.value = queryTableData.operateLogData;
              modalShow.value = true;
              modalShowCategory.value = "lastTime";
            } else {
              methods.setTimeoutAlert(response);
            }
            methods.triggerLoadingBar();
          });
          break;
        default:
          break;
      }
    };

    return {
      multiInputVal,
      multiInputItems,
      inspectTimeoutDataFields,
      inspectTimeoutDataItem,
      inspectTimeoutDetailDataFields,
      inspectTimeoutDetailDataItem,
      deviceTotalQty,
      batchTotalQty,
      inspectTotalQty,
      timeoutTotalQty,
      showDetailData,
      modalShow,
      modalShowCategory,
      inspectTimeoutShowDetail,
      inspectTimeoutRowClick,
      batch,
      inspectTabIndex,
      totalInspectionData,
      inspValue,
      queryResultTableItems,
      stacksBarClass,
      stacksBarMaxValue,
      stacksData,
      operateLogFields,
      operateLogItems,
      showDetailData,
    };
  },
};
</script>

<style>
.inspectTimeout-table table thead {
  position: sticky;
  top: 0;
}
</style>
<style scoped>
.inspectTimeout-table table thead th {
  min-width: 155px;
  font-size: 16px;
}

.inspectTimeout-table table thead tr:nth-child(1) th,
.inspectTimeout-table table thead tr:nth-child(3) th {
  background-color: #4b8c80;
  color: #ffffff;
}

.inspectTimeout-table table thead tr:nth-child(2) th {
  background-color: #ffffff;
  color: #000000;
  cursor: pointer;
}

.inspectTimeout-table table thead tr:nth-child(3) th {
  font-size: 18px;
}

.inspectTimeout-button {
  border: 0px;
  border-radius: 5px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  padding: 0 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 0.5rem;
  cursor: pointer;
}

.li-tab {
  width: 140px;
  margin-right: 0.2rem;
  padding: 0.5rem 1rem 0px;
  background-color: transparent;
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
  cursor: pointer;
}

.inspection-head-tab {
  color: #427ace;
  border-bottom: 0.6rem solid #427ace;
}

.inspection-head-tab-active {
  color: #fff;
  background-color: #427ace;
  border-radius: 0.63rem 0.63rem 0 0;
}

.inspection-thread-tab {
  color: #009245;
  border-bottom: 0.6rem solid #009245;
}

.inspection-thread-tab-active {
  color: #fff;
  background-color: #009245;
  border-radius: 0.63rem 0.63rem 0 0;
}

.inspection-tab-display-none {
  display: none;
}
</style>
